var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCaregiverList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:currentColor;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M23.7,12.1c-1-1-2.2-1.9-3.4-2.6V5.4c0-0.4-0.2-0.7-0.6-0.9c-4.9-2-10.5-2.1-15.5,0C3.9,4.6,3.7,5,3.7,5.4v4.1 c-1.2,0.7-2.4,1.6-3.4,2.6c-0.3,0.3-0.4,0.7-0.2,1.1l3.7,7.4C4,21,4.5,21.2,5,21c4.5-1.9,9.5-1.9,14,0c0.5,0.2,1,0,1.2-0.4l3.7-7.4 C24.1,12.8,24,12.4,23.7,12.1z M5.6,6c4.2-1.6,8.7-1.6,12.9,0v2.5c-4-1.7-8.7-1.8-12.9,0V6z M18.9,18.9c-4.4-1.6-9.3-1.7-13.8,0 l-3-6c5.6-5.2,14.3-5.1,19.8,0L18.9,18.9z M14.8,13.2c0,0.5-0.4,0.9-0.9,0.9h-0.9V15c0,0.5-0.4,0.9-0.9,0.9c-0.5,0-0.9-0.4-0.9-0.9 v-0.9h-0.9c-0.5,0-0.9-0.4-0.9-0.9c0-0.5,0.4-0.9,0.9-0.9h0.9v-0.9c0-0.5,0.4-0.9,0.9-0.9c0.5,0,0.9,0.4,0.9,0.9v0.9h0.9 C14.4,12.3,14.8,12.7,14.8,13.2z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaregiverList);
export default __webpack_public_path__ + "static/media/caregiverList.c6783f219b4348fdbdc93ff9b79bc594.svg";
export { ForwardRef as ReactComponent };